import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import { ThemeProvider, createTheme } from "@mui/material/styles";

export default function DeleteDialog({
    modalOpen,
    handleModalClose,
    executeConfirmed,
}) {
    const Theme = useSelector((state) => state.Theme);

    const innerform = createTheme({
        palette: {
            primary: {
                main: Theme.primaryThemeColor,
            },
        },
        typography: {
            fontFamily: "Poppins",
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        color: "#fff",
                        // fontSize: '12.5px',
                        // maxWidth: "260px",
                        // height: "30px",
                        // padding: "12px 8px 11px 8px",
                        fontWeight: 500,
                    },
                },
            },
        },
    });

    return (
        <Dialog
            onClose={handleModalClose}
            open={modalOpen}
            maxWidth={"md"}
            sx={{
                "& .MuiDialog-paper": {
                    marginTop: "-3vh"
                },
            }}
        >
            <ThemeProvider theme={innerform}>
                <IconButton
                    aria-label="close"
                    onClick={handleModalClose}
                    sx={{ position: "absolute", top: 0.1, right: 0.1 }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent sx={{ transition: "ease-in-out" }}>
                    <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleModalClose}
                            sx={{ color: "#111111" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={executeConfirmed}
                        >
                            Delete
                        </Button>
                    </Stack>
                </DialogContent>
            </ThemeProvider>
        </Dialog>
    );
}
